var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"title":this.title,"width":_vm.size,"visible":_vm.visible,"body-style":{ paddingBottom: '80px' }},on:{"close":_vm.handleCloseDrawer}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }